__turbopack_context__.v({
  "adv-slot": "410-module-scss-module__jrkAgq__adv-slot",
  "card": "410-module-scss-module__jrkAgq__card",
  "card-content": "410-module-scss-module__jrkAgq__card-content",
  "card-grid": "410-module-scss-module__jrkAgq__card-grid",
  "card-grid-item": "410-module-scss-module__jrkAgq__card-grid-item",
  "card-image": "410-module-scss-module__jrkAgq__card-image",
  "card-image-container": "410-module-scss-module__jrkAgq__card-image-container",
  "card-image-count": "410-module-scss-module__jrkAgq__card-image-count",
  "content-section": "410-module-scss-module__jrkAgq__content-section",
  "content-title": "410-module-scss-module__jrkAgq__content-title",
  "item-link": "410-module-scss-module__jrkAgq__item-link",
  "item-location": "410-module-scss-module__jrkAgq__item-location",
  "new-search-link": "410-module-scss-module__jrkAgq__new-search-link",
  "specific-listing-link": "410-module-scss-module__jrkAgq__specific-listing-link",
  "title-image": "410-module-scss-module__jrkAgq__title-image",
  "title-section": "410-module-scss-module__jrkAgq__title-section",
  "title-text": "410-module-scss-module__jrkAgq__title-text",
  "top-level-section": "410-module-scss-module__jrkAgq__top-level-section",
});
